import React, { useState, useContext, useEffect } from "react";
import "./index.scss";
import { NetGetCheckIn, UserManager } from "../../actions";
import { Context } from "../../stores";
import Modal from "./Modal";
import { useTranslation } from "react-i18next";

const CheckIn = () => {
  const { t } = useTranslation();
  const [num, setNum] = useState<string>("");
  const [modal, setModal] = useState<any>({
    status: 0,
    data: ""
  });
  const numArr = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const Store = useContext(Context);
  const branch = UserManager().getUser()?.branch;

  useEffect(() => {
    // 체크인 화면 생성시 body 스크롤 제거
    const body = document.querySelector("body");
    if (body) {
      body.style.overflowY = "hidden";
    }

    return () => {
      if (body) {
        body.style.overflowY = "scroll";
      }
    };
  }, []);

  // const dispatch = useDispatch();
  const handleSubmit = () => {
    Store.actions.setSending(true);
    NetGetCheckIn(num)
      .then((res: any) => {
        setModal({ status: 1, data: res.data.Data });
        Store.actions.setSending(false);
        // dispatch(onModal('checkin', { modal }));
      })
      .catch(err => {
        if (err) {
          setModal({
            status: 2,
            data: ""
          });
        }
        Store.actions.setSending(false);
        // dispatch(onModal('checkin', { modal }));
      });
  };

  return (
    <div className="checkin">
      <div>
        <div className="text">
          {/*<img*/}
          {/*  src="/images/checkin_top_logo.png"*/}
          {/*  alt="top_logo"*/}
          {/*  className="top-logo_image"*/}
          {/*/>*/}
          {/*<span className="branch-name">{branch?.name}</span>*/}
          <div className="center-text">
            {t("checkin.welcome")}
            <br />
            {branch?.name}
            <br />
            {t("checkin.enjoyGolf")}
          </div>
        </div>
        <div className="footer">
          {/*<div className="footer-title">행복골프GO 어플리케이션</div>*/}
          <div className="footer-title">{t("checkin.system")}</div>
          <div className="qr-container">
            <div>
              <img
                className="qr-image"
                src="/images/qr_android.png"
                alt="android"
              />
              {/*<div className="qr-text">안드로이드</div>*/}
              <div className="qr-text">{t("checkin.android")}</div>
            </div>
            <div className="vertical-line" />
            <div>
              <img className="qr-image" src="/images/qr_iOS.png" alt="iOS" />
              {/*<div className="qr-text">iOS</div>*/}
              <div className="qr-text">{t("checkin.ios")}</div>
            </div>
          </div>
        </div>
      </div>
      <div className="number">
        <div className="number_text">{num}</div>
        <div className="number_pad">
          {numArr.map((n: any) => (
            <div
              key={n}
              className="pad"
              onClick={() => {
                setNum(num + n);
              }}
            >
              {n}
            </div>
          ))}
          <div
            className="pad btn_del"
            onClick={() => {
              setNum(num.slice(0, -1));
            }}
          >
            ←
          </div>
          <div
            className="pad"
            onClick={() => {
              setNum(num + "0");
            }}
          >
            0
          </div>
          <div
            className="pad btn_clear"
            onClick={() => {
              setNum("");
            }}
          >
            ✕
          </div>
        </div>
        <div
          className={`number_checkin ${num && `number_checkin_ok`}`}
          onClick={handleSubmit}
        >
          체크인
        </div>
      </div>
      {modal.status !== 0 && (
        <Modal
          modal={modal}
          num={num}
          onClickExit={() => {
            setModal({ status: 0, data: "" });
            setNum("");
          }}
        />
      )}
    </div>
  );
};

export default CheckIn;
